var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.2126L19.7718 16.028C19.1245 15.4994 18.5578 14.8931 18.0872 14.2256C17.5733 13.3044 17.2653 12.2985 17.1812 11.2667V8.22779C17.1857 6.60722 16.5443 5.04093 15.3777 3.82322C14.211 2.6055 12.5994 1.82018 10.8456 1.6148V0.821241C10.8456 0.603435 10.7512 0.394549 10.5832 0.240536C10.4152 0.0865235 10.1873 0 9.94966 0C9.71204 0 9.48414 0.0865235 9.31612 0.240536C9.14809 0.394549 9.05369 0.603435 9.05369 0.821241V1.6271C7.31561 1.84729 5.72347 2.63736 4.57217 3.85098C3.42086 5.0646 2.78841 6.61954 2.79195 8.22779V11.2667C2.70789 12.2985 2.39985 13.3044 1.88591 14.2256C1.42341 14.8914 0.865903 15.4976 0.228188 16.028L0 16.2126V17.9474H20V16.2126Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23486 18.5933C8.29372 18.9832 8.50452 19.3404 8.82834 19.599C9.15217 19.8576 9.56714 20 9.99661 20C10.4261 20 10.841 19.8576 11.1649 19.599C11.4887 19.3404 11.6995 18.9832 11.7584 18.5933H8.23486Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationbell);
export default __webpack_public_path__ + "static/media/NOTIFICATION BELL.7a670768717d717141c0115531455258.svg";
export { ForwardRef as ReactComponent };